import Vue from 'vue'
import VueRouter from 'vue-router'
import HeaderLeftRail from '@/layouts/HeaderLeftRail.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/loginPage.vue'),
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/registration/registrationPage'),
  },
  {
    path: '/enterpriseRegistration',
    name: 'enterpriseRegistration',
    component: () => import('@/views/registration/enterpriseRegistration'),
  },
  {
    path: '/home',
    name: 'home',
    component: HeaderLeftRail,
    redirect: '/workTable',
    children: [
      {
        path: '/workTable',
        name: '工作台',
        component: () => import('@/views/workTable/workTable.vue'),
      },
      {
        path: '/personalInformation',
        name: '个人信息',
        component: () =>
          import('@/views/personalInformation/personalInformation.vue'),
      },
      {
        path: '/applyManage',
        name: '报名管理',
        component: () => import('@/views/applyManage/applyManage.vue'),
      },
      {
        path: '/examManage',
        name: '考试管理',
        component: () => import('@/views/examManage/examManage.vue'),
      },
      {
        path: '/certificateManage',
        name: '证书管理',
        component: () =>
          import('@/views/certificateManage/certificateManage.vue'),
      },
      {
        path: '/companyBaseMessage',
        name: '企业基本信息管理',
        component: () =>
          import('@/views/companyBaseMessage/companyBaseMessage.vue'),
      },
      {
        path: '/emptyManage',
        name: '员工管理',
        component: () => import('@/views/emptyManage/emptyManage.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  routes,
})

// 注册一个全局前置守卫

router.beforeEach((to, from, next) => {
  const userInfo = store.state.userInfo
  if (
    to.name === 'login' ||
    to.name === 'registration' ||
    to.name === 'enterpriseRegistration'
  ) {
    next()
    return
  } else {
    if (userInfo.id) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})

export default router
